import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-onroerende-zaken',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-onroerende-zaken.component.html',
  styleUrl: './tekst-onroerende-zaken.component.scss',
})
export class TekstOnroerendeZakenComponent {}
